var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "up-down-arrow",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": 10
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M24 0v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 18a.76.76 0 0 1-.75-.75V8.56l-2 2a.75.75 0 0 1-1.06 0 .75.75 0 0 1 0-1.06l3.28-3.28a.63.63 0 0 1 .24-.16.73.73 0 0 1 .58 0 .63.63 0 0 1 .24.16l3.25 3.25a.75.75 0 0 1-1.06 1.06l-2-2v8.69A.76.76 0 0 1 8 18Zm8-12a.76.76 0 0 0-.75.75v8.69l-2-2a.75.75 0 0 0-1.06 0 .75.75 0 0 0 0 1.06l3.25 3.25a.63.63 0 0 0 .24.16.73.73 0 0 0 .58 0 .63.63 0 0 0 .24-.16l3.25-3.25a.75.75 0 0 0-1.06-1.06l-2 2V6.75A.76.76 0 0 0 16 6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpDownArrow);
export default __webpack_public_path__ + "static/media/up-down-arrow.fa72a7b4c0792eae2b24da3fdb52ee73.svg";
export { ForwardRef as ReactComponent };